import React, { useEffect, useState } from 'react';
import Animated, {
  runOnJS,
  runOnUI,
  useAnimatedReaction,
  useSharedValue,
} from 'react-native-reanimated';
import { styled } from 'dripsy';
import { View } from 'react-native';

import { IS_WEB } from '@utils';
import { BaseText } from '../../common/BaseText';

const Container = styled(View)({
  borderRadius: 12,
  overflow: 'hidden',
  maxWidth: '90%',
});

const Background = styled(View)({
  position: 'absolute',
  zIndex: -1,
  width: '100%',
  height: '100%',
  bg: '$black',
  opacity: 0.7,
});

const Text = styled(BaseText)({
  py: '$2',
  px: '$4',
  color: '$background0',
  variant: IS_WEB ? 'text.xxxlarge' : 'text.small',
  textAlign: 'center',
});

function findText(
  progress: Animated.SharedValue<number>,
  subtitles: Animated.SharedValue<SubtitlesType>,
) {
  'worklet';

  return subtitles.value.find(
    (v) => v.start < progress.value && v.end > progress.value,
  );
}

interface ISubtitlesPartType {
  id: number;
  text: string;
  start: number;
  end: number;
}

export type SubtitlesType = ISubtitlesPartType[];

interface ISubtitlesTextProps {
  progress: Animated.SharedValue<number>;
  subtitles: SubtitlesType;
}

type CurrentSubtitleType =
  | ISubtitlesPartType
  | {
      id: null;
    };

export function SubtitlesText({
  progress,
  subtitles,
}: ISubtitlesTextProps) {
  const sharedSubtitles = useSharedValue<SubtitlesType>(subtitles);
  const [part, setPart] = useState<CurrentSubtitleType>({
    id: null,
  });

  useEffect(() => {
    if (subtitles) {
      runOnUI(() => {
        'worklet';

        sharedSubtitles.value = subtitles;
      })();
    }
  }, [subtitles]);

  function updateText(newPart?: ISubtitlesPartType) {
    if (newPart && newPart?.id !== part.id) {
      setPart(newPart);
    } else if (!newPart) {
      setPart({ id: null });
    }
  }

  useAnimatedReaction(
    () => progress,
    (result) => {
      const newPart = findText(result, sharedSubtitles);

      runOnJS(updateText)(newPart);
    },
  );

  if (part.id === null) {
    return null;
  }

  return (
    <Container>
      <Background />
      <Text>{part.text}</Text>
    </Container>
  );
}
